import React, { FC } from 'react';
import { BackdropContainer } from './backdrop.style';
import { BackdropProps } from './backdrop.types';

const DEFAULT_DATA_ATTR = { 'data-testid': 'modal__backdrop' };

const Backdrop: FC<BackdropProps> = ({
  dataAttr = {},
  ...props
}) => {
  const combinedDataAttr = {...DEFAULT_DATA_ATTR, ...dataAttr};
  return (
    <BackdropContainer
      aria-hidden
      {...props}
      {...combinedDataAttr}
    />
  );
};

export default React.memo(Backdrop);
